module.exports = __webpack_public_path__ + "img/4.5793df14.png";